export function handlePopupOnScroll(popupSelector = '.become-supporter-popup', scrollTrigger = 50, closeSelector = '.become-supporter-close') {
    const popup = document.querySelector(popupSelector);
    const closeBtn = document.querySelector(closeSelector);

    if (!popup || !closeBtn) {
        return;
    }

    function setCookie(name, value, hours) {
        const date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function checkPopup() {
        if (!getCookie('popupClosed')) {
            document.addEventListener('scroll', checkScrollPosition);
        }
    }

    function checkScrollPosition() {
        const scrollPosition = window.scrollY;
        const windowHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercentage = (scrollPosition / windowHeight) * 100;

        if (scrollPercentage > scrollTrigger) {
            popup.classList.add('visible');
            // popup.style.display = 'block';
        }
    }

    function closePopup(e) {
        popup.classList.remove('visible');
        // popup.style.display = 'none';
        setCookie('popupClosed', 'true', 24);
        document.removeEventListener('scroll', checkScrollPosition);
        e.preventDefault();
        return false;
    }

    closeBtn.addEventListener('click', closePopup);
    checkPopup();
}
